// extracted by mini-css-extract-plugin
export var answer = "bx_gW";
export var arrow = "bx_9";
export var body = "bx_c";
export var category = "bx_c2";
export var contactIcons = "bx_gP";
export var current = "bx_fz";
export var fade = "bx_gS";
export var footer = "bx_cb";
export var footerText = "bx_cc";
export var icon = "bx_bq";
export var iconContainer = "bx_dy";
export var issue = "bx_gV";
export var issueContainer = "bx_gR";
export var issueText = "bx_gT";
export var issues = "bx_gQ";
export var left = "bx_bT";
export var padding = "bx_dQ";
export var right = "bx_cv";
export var section = "bx_d";
export var selectors = "bx_dR";
export var subtitle = "bx_cj";
export var title = "bx_h";